import 'whatwg-fetch';

import { BASE_URL } from '../const';
import { mogamboRequestV2, mogamboRequestV3 } from './utils';

export const getMetaInfoAsync = async (key, value) => {
  const url = `${BASE_URL}meta/${key}/${value}/`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.status) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const getConnectionsToNodeAsync = async (toNodeId) => {
  const url = `${BASE_URL}node/connections/${toNodeId}/`;
  const response = await mogamboRequestV2(url, 'GET');
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const setConnectionsToNodeAsync = async (nodeId, data) => {
  const url = `${BASE_URL}node/connections/${nodeId}/`;
  const response = await mogamboRequestV2(url, 'POST', data);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const deleteConnectionsToNodeAsync = async (nodeId, data) => {
  const url = `${BASE_URL}node/connections/${nodeId}/`;
  const response = await mogamboRequestV2(url, 'POST', data);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const updateNodeData = async (nodeId, data) => {
  const url = `${BASE_URL}node/data/${nodeId}/`;
  const response = await mogamboRequestV2(url, 'POST', data);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const moveNodesAsync = async (nodes, toSubStory, domainTitle) => {
  const headers = {
    'x-haptik-bot-name': domainTitle,
  };
  const data = {
    nodes: nodes.map((node) => node.id),
    sub_story: toSubStory.id,
  };
  const url = `${BASE_URL}move_nodes/`;
  const response = await mogamboRequestV2(url, 'POST', data, false, headers);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const createNode = async (data) => {
  const url = `${BASE_URL}node/create/`;
  const headers = {
    'x-haptik-bot-name': data.domain_name,
  };
  const response = await mogamboRequestV2(url, 'POST', data, false, headers);
  if (response.success) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};

export const validateGenAiNode = async (data, domainId) => {
  const url = `${BASE_URL}v1/domains/${domainId}/validate_genai_node_data/`;
  const response = await mogamboRequestV3(url, 'POST', data);
  if (response.meta || response.body) {
    return Promise.resolve(response);
  }
  return Promise.reject(response);
};
